
import { defineComponent } from 'vue'
import EventCard from '@/components/block/EventCard.vue'
import dayjs from 'dayjs'
import 'dayjs/locale/ja'
dayjs.locale('ja')
import {
  getEventTerm,
  getEventPlace,
  getEventTypes
} from '@/utils/commonMethods'

export default defineComponent({
  name: 'EventCardMypage',

  components: {
    EventCard
  },

  props: {
    event: Object,
    rectangle: {
      type: Boolean,
      default: false
    },
    clickCancel: Function
  },

  setup(props: any) {
    const checkFinished = () => {
      if (
        props.event.term_end &&
        dayjs().isAfter(dayjs(props.event.term_end), 'day')
      )
        return true

      return false
    }
    const isFinished = checkFinished()

    return {
      getEventTerm,
      getEventPlace,
      getEventTypes,
      isFinished
    }
  }
})
